/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { en_US, zh_CN } from '@coze-arch/coze-design/locales';

export const enUSDesign: typeof en_US = {
  ...en_US,
  platform_name: 'Agent Studio',
};

export const zhCNDesign: typeof zh_CN = {
  ...zh_CN,
  platform_name: 'Agent Studio',
};

export const zhHKDesign: typeof zh_CN = {
  ...zhCNDesign,
  locale: 'zh-HK',
  delete_title: '刪除',
  cancel: '取消',
  confirm: '確定',
  delete_desc: '此操作無法還原',
  Copy: '複製',
  Edit: '編輯',
  Delete: '刪除',
  loaded: '載入完成',
  loading: '載入中',
};
